
import { div, h2, anchor, form, button, br, textnode } from "../../shared/dom";
import { SVG } from "../../shared/svg";
import { App } from "./app";
import { Loading } from "../../shared/loading";
import { ApiErrorResponse, ApiLoginRequest, ApiUser, ApiInviteRequest, ApiActivateRequest } from "./api_data";
import { Ajax } from "../../shared/ajax";

export class Auth {

  static input(placeholder: string, autocomplete: string, type: string, name: string): HTMLInputElement {
    const i = App.input();
    i.placeholder = placeholder;
    i.spellcheck = false;
    if (autocomplete !== "") {
      i.autocomplete = autocomplete;
    }
    i.autocapitalize = "off";
    i.type = type;
    if (name !== "") {
      i.name = name;
    }
    return i;
  }

  static render_signup(root: HTMLElement) {
    root.innerHTML = "";
    const d = div("h-100", "c-flex");
    const frame = div("h-100", "c-flex", "top");
    d.appendChild(frame);

    const top = div("c-flex");
    const h = h2();
    h.innerText = "Request Access";
    top.appendChild(h);
    const message = div("msg", "txt-c");
    message.innerText = "Enter your email to join the waitlist.";
    message.appendChild(br());
    message.appendChild(textnode("Already have an account? "));
    const link = anchor();
    link.innerText = "Sign In.";
    link.href = "/login";
    App.enable_link(link);
    message.appendChild(link);
    top.appendChild(message);

    frame.appendChild(top);

    const bottom = div("footer-buttons");
    const f = form();
    bottom.appendChild(f);

    const email = Auth.input("Email", "email", "text", "email");
    f.appendChild(email);

    const sign_up = button("key");
    sign_up.innerText = "Join Waitlist";

    const loading = Loading.overlay();
    sign_up.appendChild(loading);

    const send = function () {
      if (email.value === "") {
        return;
      }
      sign_up.classList.add("working");
      sign_up.disabled = true;
      error.style.display = "none";
      confirm.style.display = "none";
      const req: ApiInviteRequest = {
        email: email.value
      }
      Ajax.post("/api/v1/request_invite", function () {
        confirm.style.display = "block";
        email.value = "";
        sign_up.classList.remove("working");
        sign_up.disabled = false;
      }, req, function (_: number, data: ApiErrorResponse) {
        if (data.message !== undefined) {
          console.log(data.message);
          error.innerHTML = data.message;
          error.style.display = "block";
        }
        sign_up.disabled = false;
        sign_up.classList.remove("working");
      });
    }

    sign_up.onclick = function () {
      send();
    }

    f.onsubmit = function (e) {
      e.preventDefault();
      send();
    }

    f.appendChild(sign_up);
    const error = div("msg", "error");
    error.style.display = "none";
    bottom.appendChild(error);
    const confirm = div("msg", "txt-c");
    confirm.style.display = "none";
    confirm.innerText = "Thanks! Your email has been added to the waitlist.";
    bottom.appendChild(confirm);
    frame.appendChild(bottom);

    root.appendChild(d);
    email.focus();
  }

  static render_activate(root: HTMLElement, token: string) {
    root.innerHTML = "";
    const d = div("h-100", "c-flex");
    const frame = div("h-100", "c-flex", "top");
    d.appendChild(frame);

    const top = div("c-flex");
    top.appendChild(SVG.logo("logo-small"));
    const h = h2();
    h.innerText = "Create your Account";
    top.appendChild(h);
    const message = div("msg");
    message.appendChild(textnode("Already have an account? "));
    const link = anchor();
    link.innerText = "Sign In.";
    link.href = "/login";
    App.enable_link(link);
    message.appendChild(link);
    top.appendChild(message);

    frame.appendChild(top);

    const bottom = div("footer-buttons");
    const f = form("v");
    bottom.appendChild(f);

    const error = div("msg", "error");
    error.style.display = "none";
    bottom.appendChild(error);

    const email = Auth.input("Email", "email", "text", "email");
    f.appendChild(email);

    const pass = Auth.input("Password", "new-password", "password", "password");
    f.appendChild(pass);

    const sign_up = button("key");
    sign_up.innerText = "Sign Up";
    sign_up.disabled = true;
    sign_up.style.opacity = "0.4";

    const loading = Loading.overlay();
    sign_up.appendChild(loading);

    const show_error = function (message: string) {
      error.innerHTML = message;
      error.style.display = "block";
    }

    const hide_error = function () {
      error.innerHTML = "";
      error.style.display = "none";
    }

    const check_lengths = function () {
      if (email.value.length < 1 || pass.value.length < 6) {
        sign_up.style.opacity = "0.4";
        sign_up.disabled = true;
      } else {
        sign_up.style.opacity = "1";
        sign_up.disabled = false;
      }
    }

    const x = "x";
    const add_events = function (i: HTMLInputElement, min_length: number) {
      i.onfocus = function () {
        i.classList.remove(x);
        hide_error();
      }
      i.onblur = function () {
        if (i.value.length < min_length) {
          i.classList.add(x);
        }
      }
      i.oninput = function () {
        check_lengths();
      }
    }

    add_events(email, 1);
    add_events(pass, 6);

    const send = function () {
      if (email.value.length < 1 || pass.value.length < 6) {
        return;
      }
      sign_up.classList.add("working");
      sign_up.disabled = true;
      const req: ApiActivateRequest = {
        email: email.value,
        token: token,
        password: pass.value,
      }

      const on_success = function (_d: ApiUser) {
        // TODO: load data
        App.navigate("/");
      }

      const on_error = function (_: number, data: ApiErrorResponse) {
        if (data.message !== undefined) {
          show_error(data.message);
          console.log(data.message);
        }
        sign_up.disabled = false;
        sign_up.classList.remove("working");
      }

      Ajax.post("/api/v1/activate", on_success, req, on_error);
    }

    sign_up.onclick = function () {
      send();
    }

    f.onsubmit = function (e) {
      e.preventDefault();
      send();
    }

    f.appendChild(sign_up);
    frame.appendChild(bottom);

    const terms = div("msg", "txt-c");
    terms.style.marginTop = "16px";
    terms.innerText = "By signing up you acknowledge that you have read, and agree to our "
    const terms_link = anchor();
    terms_link.innerText = "Terms of Service";
    terms.appendChild(terms_link);
    terms.appendChild(textnode(" and "));
    const privacy_link = anchor();
    privacy_link.innerText = "Privacy Policy.";
    terms.appendChild(privacy_link);
    bottom.appendChild(terms);

    root.appendChild(d);
    email.focus();
  }

  static render_login(root: HTMLElement) {
    root.innerHTML = "";
    const d = div("h-100", "c-flex");
    const frame = div("h-100", "c-flex", "top");
    d.appendChild(frame);

    const top = div("c-flex");
    const logo = anchor();
    logo.appendChild(SVG.logo("logo-small"));
    logo.href = "/";
    top.appendChild(logo);
    const h = h2();
    h.innerText = "Welcome Back";
    top.appendChild(h);
    const message = div("msg", "txt-c");
    message.innerText = "Don't have an account? ";
    const link = anchor();
    link.innerText = "Sign Up.";
    link.href = "/";
    message.appendChild(link);
    top.appendChild(message);
    frame.appendChild(top);

    App.enable_link(link);

    const bottom = div("footer-buttons");
    const f = form();
    bottom.appendChild(f);

    const email = Auth.input("Email", "email", "text", "email");
    f.appendChild(email);

    email.onkeydown = function (e) {
      console.log(e);
    }

    const pass = App.input();
    pass.placeholder = "Password";
    pass.type = "password";
    pass.autocomplete = "current-password";
    f.appendChild(pass);

    const sign_in = button("key");
    sign_in.innerText = "Log In";

    const loading = Loading.overlay();
    sign_in.appendChild(loading);

    f.appendChild(sign_in);

    const error = div("msg", "error");
    error.style.display = "none";
    bottom.appendChild(error);
    frame.appendChild(bottom);

    root.appendChild(d);
    email.focus();

    const login_ok = function (_d: ApiUser) {
      App.get_user_data(function () {
        App.navigate("/");
      });
    }

    const login_fail = function (_: number, data: ApiErrorResponse) {
      if (data.message !== undefined) {
        console.log(data.error);
        error.innerHTML = data.message;
        error.style.display = "block";
      }
      sign_in.disabled = false;
      sign_in.classList.remove("working");
    }

    const login = function () {
      if (email.value.length < 1 || pass.value.length < 1) {
        return;
      }
      sign_in.classList.add("working");
      const req: ApiLoginRequest = {
        email: email.value,
        password: pass.value,
      }
      sign_in.disabled = true;
      error.style.display = "none";
      Ajax.post("/api/v1/login", login_ok, req, login_fail);
    }

    f.onsubmit = function (e) {
      e.preventDefault();
      login();
    }

    sign_in.onclick = function (e) {
      e.preventDefault();
      login();
    }
  }

}